import React, { Component} from 'react';
import { observer, inject } from 'mobx-react';
import ItemModify from '../Form/ItemModify';

@inject('inventoryPcategoryStore')
@observer
class PcategoryModify extends Component {
  render() {
    const { inventoryPcategoryStore, params } = this.props;
    return (
      <ItemModify
      title='Product Category'
      slug = '/inventory/pcategory'
      store = {inventoryPcategoryStore}
      itemFields = {[
        { label: 'Id', key: 'id', type: 'text', readOnly : true, editOnly : true},
        { label: 'Name', key: 'name', type: 'text' },
        { label: 'Description', key: 'description', type: 'text' },
        { label: 'Parent', key: 'parent_id', type: 'text' },
      ]}
      params={params}
      />
    );
  }
}

export default PcategoryModify;



// WEBPACK FOOTER //
// ./src/components/Inventory/PcategoryModify.js